import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal, ModalContentWrapper, ModalActionWrapper, Button } from '@sumtotal/react-foundation';

function RouteLeavingConfirmationModal({ isOpen, handleModalAction }) {
  const { t } = useTranslation(['TRANSLATIONS_RCORE_COMMON']);
  return (
    <Modal
      title={t('RCORE_COMMON_CONFIRM_NAVIGATION_TITLE')}
      open={isOpen}
      onClose={() => handleModalAction(false)}
    >
      <ModalContentWrapper>
        <p>{t('RCORE_COMMON_CONFIRM_NAVIGATION_MESSAGE')}</p>
      </ModalContentWrapper>
      <ModalActionWrapper>
        <Button variant="secondary" onClick={() => handleModalAction(false)}>
          {t('RCORE_COMMON_CANCEL')}
        </Button>
        <Button variant="primary" onClick={() => handleModalAction(true)}>
          {t('RCORE_COMMON_OK')}
        </Button>
      </ModalActionWrapper>
    </Modal>
  );
}

RouteLeavingConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  handleModalAction: PropTypes.func
};

RouteLeavingConfirmationModal.defaultProps = {
  isOpen: false,
  handleModalAction: () => {}
};

export default RouteLeavingConfirmationModal;
